import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ToxicityDialogComponent, ToxicityDialogData } from "../components/dialogs/toxicity-dialog/toxicity-dialog.component";
import { OrganisationSidoDialogComponent, OrganisationSidoDialogData } from "../components/dialogs/organisation-sido-dialog/organisation-sido-dialog.component";
import { SimilarOrganisationSidoDialogComponent, SimilarOrganisationSidoDialogData } from "../components/dialogs/similar-organisation-sido-dialog/similar-organisation-sido-dialog.component";
import { ChangeStatusDialogComponent, ChangeStatusDialogData } from "../components/dialogs/change-status-dialog/change-status-dialog.component";
import { ConfirmationDialogComponent, ConfirmationDialogData } from "../components/dialogs/confirmation-dialog/confirmation-dialog.component";
import { ContactDetailsDialogComponent, ContactDetailsDialogData } from "../components/dialogs/contact-details-dialog/contact-details-dialog.component";
import { HistoryDialogComponent, HistoryDialogData } from "../components/dialogs/history-dialog/history-dialog.component";
import { RequestSenderIdDialogComponent, RequestSenderIdDialogData } from "../components/dialogs/request-sender-id-dialog/request-sender-id-dialog.component";
import { PendingOpasAuthorisationsDialogComponent, PendingOpasAuthorisationsDialogData } from "../components/dialogs/pending-opas-authorisations-dialog/pending-opas-authorisations-dialog.component";
import { AuthorisedOpasDialogData, AuthorisedOpasDialogComponent } from "../components/dialogs/authorised-opas-dialog/authorised-opas-dialog.component";
import { UpdateBlockListDialogComponent, UpdateBlockListDialogData } from "../components/dialogs/update-block-list-dialog/update-block-list-dialog.component";
import { AddThirdPartyDialogComponent, UpdateThirdPartyDialogData } from "../components/dialogs/add-third-party-dialog/add-third-party-dialog.component";
import { AuthorisedSenderIdsDialogComponent, AuthorisedSenderIdsDialogData } from "../components/dialogs/authorised-sender-ids-dialog/authorised-sender-ids-dialog.component";
import { PendingSenderIdsDialogComponent } from "../components/dialogs/pending-sender-ids-dialog/pending-sender-ids-dialog.component";
import { ThirdPartiesDialogComponent, ThirdPartiesDialogData } from "../components/dialogs/third-parties-dialog/third-parties-dialog.component";
import { TokenGenerationDialogComponent } from "../components/dialogs/token-generation-dialog/token-generation-dialog.component";
import { NotesDialogComponent, NotesDialogData } from "../components/dialogs/notes-dialog/notes-dialog.component";

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  readonly dialog = inject(MatDialog);

  openStatusChange(data: ChangeStatusDialogData) {
    return this.dialog.open(ChangeStatusDialogComponent, { data, autoFocus: false });
  }

  openToxicity(data: ToxicityDialogData) {
    return this.dialog.open(ToxicityDialogComponent, { data, autoFocus: false });
  }

  openOrganisationSido(data: OrganisationSidoDialogData) {
    return this.dialog.open(OrganisationSidoDialogComponent, { data, autoFocus: false });
  }

  openSimilarOrganisationSido(data: SimilarOrganisationSidoDialogData) {
    return this.dialog.open(SimilarOrganisationSidoDialogComponent, { data, autoFocus: false });
  }

  openConfirmation(data?: ConfirmationDialogData) {
    return this.dialog.open(ConfirmationDialogComponent, { data, autoFocus: false });
  }

  openContactDetails(data: ContactDetailsDialogData) {
    const width = '500px';
    return this.dialog.open(ContactDetailsDialogComponent, { data, width, autoFocus: false });
  }

  openHistory(data: HistoryDialogData) {
    return this.dialog.open(HistoryDialogComponent, { data, autoFocus: false, panelClass: 'history-dialog' });
  }

  openRequestSenderId(data: RequestSenderIdDialogData) {
    return this.dialog.open(RequestSenderIdDialogComponent, { data, autoFocus: false });
  }

  openPendingOpas(data: PendingOpasAuthorisationsDialogData) {
    return this.dialog.open(PendingOpasAuthorisationsDialogComponent, { data, autoFocus: false });
  }

  openAuthorisedOpas(data: AuthorisedOpasDialogData) {
    return this.dialog.open(AuthorisedOpasDialogComponent, { data, autoFocus: false });
  }

  openUpdateBlockList(data: UpdateBlockListDialogData) {
    return this.dialog.open(UpdateBlockListDialogComponent, { data, autoFocus: false });
  }

  openUpdateThirdParties(data: UpdateThirdPartyDialogData) {
    return this.dialog.open(AddThirdPartyDialogComponent, { data, autoFocus: false });
  }

  openAuthorisedSenderIds(data: AuthorisedSenderIdsDialogData) {
    return this.dialog.open(AuthorisedSenderIdsDialogComponent, { data, autoFocus: false });
  }

  openAllPendingSenderIds() {
    return this.dialog.open(PendingSenderIdsDialogComponent, { autoFocus: false });
  }

  openThirdParties(data: ThirdPartiesDialogData) {
    return this.dialog.open(ThirdPartiesDialogComponent, { data, autoFocus: false });
  }

  openTokenGeneration() {
    return this.dialog.open(TokenGenerationDialogComponent, { autoFocus: false });
  }

  openNotes(data: NotesDialogData) {
    return this.dialog.open(NotesDialogComponent, { data, width: '564px', autoFocus: false });
  }
}
